// print button
const PrintButton = (function PrintButton() {
    const printIcon = document.querySelector(".icon-print");
    const printButton = printIcon && printIcon.closest(".btn");

    function attachEvents() {
        printButton && printButton.addEventListener("click", e => {
            window.print();
            e.preventDefault();
        }, false);
    }

    function init() {
        attachEvents();
    }

    return {
        init: init,
    };
}());

window.addEventListener("load", function() {
    PrintButton.init();
});
